import * as React from "react";
const SvgPlus = props => <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} fill="#3A8EE9" viewBox="0 0 10 10" {...props}><path d="M5.624 4.376V0H4.376v4.376H0v1.248h4.376V10h1.248V5.624H10V4.376z" /></svg>;
export default SvgPlus;